import { render, staticRenderFns } from "./DetailPost.vue?vue&type=template&id=1005d345&scoped=true&"
import script from "./DetailPost.vue?vue&type=script&lang=js&"
export * from "./DetailPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1005d345",
  null
  
)

export default component.exports